import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import Navbar from './components/Navbar';
import Hero from './components/Home/Hero';
import ProductSlider from './components/Home/ProductSlider';
import ProductPage from './components/Product/ProductPage';
import News from './components/Home/News';
import NewsPage from './components/News/NewsPage';
import NewsList from './components/News/NewsList';
import ContactPage from './components/Contact/ContactPage';
import AboutPage from './components/About/AboutPage';
import Footer from './components/Footer';
import {useLocation} from "react-router";

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700',
      light: '#FFF2CC',
      dark: '#DAA520',
    },
    secondary: {
      main: '#000000',
      light: '#1a1a1a',
      dark: '#000000',
    },
    background: {
      default: '#000000',
      paper: '#121212',
    },
    text: {
      primary: '#FFD700',
      secondary: 'rgba(255, 215, 0, 0.7)',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h2: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h3: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h4: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h5: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    h6: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    //'"Playfair Display", serif'
  },
});

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <div style={{ minHeight: '100vh', backgroundColor: '#000000', fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', }}>
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <ProductSlider />
                {/*<News />*/}
              </>
            } />
            <Route path="/product/*" element={<ProductPage />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:newsId" element={<NewsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
